import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/shared/commons/alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TagService } from '../../tags/tag.service';
import { ImageService } from '../image.service';
import { Router } from '@angular/router';
import AppConstants from 'src/app/shared/commons/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from '../../product/product.service';
@Component({
  selector: 'app-addimage',
  templateUrl: './addimage.component.html',
  styleUrls: ['./addimage.component.css'],
})
export class AddimageComponent implements OnInit {
  errorDialog: any;
  successDialog: any;
  somethingWrong: any;
  baseURL = AppConstants.SERVICE_BASE_URL;
  hair_length = AppConstants.hair_length;
  hair_type = AppConstants.hair_type;
  hair_color = AppConstants.hair_color;
  skinColorList = AppConstants.skinColorList;
  age = AppConstants.age;
  category_list = AppConstants.category_list;
  faceshapeList: any = [];
  imageId: any;
  imgurl: any;
  skinColorArray: any = [];
  editData: any;
  isAddMode: boolean = true;
  tagarray: any = [];
  request: any = {};
  private image: any;
  imageUrl: any;
  hairLengthArray: any = [];
  hairTypehArray: any = [];
  hairColorArray: any = [];
  ageArray: any = [];
  gendervalue = 2;
  harmonyvalue = true;
  submitted = false;
  tagList: any = [];
  images: string[] = [];
  productList:any[]=[];
  selected:any;
  constructor(
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    public tagService: TagService,
    public alertService: AlertService,
    public imageService: ImageService,
    public router: Router,
    public productService:ProductService
  ) {}
  imageform = new FormGroup({});
  createValidation() {
    this.imageform = this.formBuilder.group({
      image_path_name: ['', [Validators.required]],
      fileSource: [''],
      category: ['', Validators.required],
      faceshape: ['', Validators.required],
      gender: ['', Validators.required],
      harmony: ['', Validators.required],
      skin_colour: [''],
      tags: [''],
      hair_length: [''],
      hair_type: [''],
      hair_color: [''],
      age: [''],
      products:['']
    });
  }
  editvalidation() {
    this.imageform = this.formBuilder.group({
      image_path_name: [''],
      fileSource: [''],
      category: ['', Validators.required],
      faceshape: [''],
      gender: ['', Validators.required],
      harmony: ['', Validators.required],
      skin_colour: [''],
      tags: [''],
      hair_length: [''],
      hair_type: [''],
      hair_color: [''],
      age: [''],
      products:['']
      
    });
  }

  ngOnInit(): void {
    this.getFaceShapeList();
    this.getTagList();
    this.getAllProduct();
    this.errorDialog = this.translateService.instant('error');
    this.somethingWrong = this.translateService.instant('something');
    this.successDialog = this.translateService.instant('success');
    this.imageId = localStorage.getItem('image_id');
    if (this.imageId != null) {
      this.isAddMode = false;
      this.editImage(this.imageId);
      this.editvalidation();
    } else {
      this.createValidation();
    }
  }
  onFileChange($event: any) {
    const files = $event.target.files || $event.srcElement.files;
    const file = files[0];
    const type = this.checkExtension(file);
    if (file && type != -1) {
      this.image = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
      };
    } else {
      let imageValidation = this.translateService.instant('imageValidation');
      this.alertService.showDangerAlert(this.errorDialog, imageValidation);
    }
  }
  getFaceShapeList() {
    this.imageService.getFaceShapeList().subscribe(
      (data) => {
        let face: any = data;
        this.faceshapeList = face['data'];
        // localStorage.setItem('faceshapeList', JSON.stringify(this.faceshapelist));
        // console.log(this.faceshapelist);
      },
      (error: HttpErrorResponse) => {
        // this.alertService.showDangerAlert(this.errorDialog,this.somethingWrong);
      }
    );
  }
  onSubmit() {
    this.submitted = true;
    this.formValidation.gender.setValue(this.gendervalue);
    this.formValidation.harmony.setValue(this.harmonyvalue);
    this.formValidation.tags.setValue(this.tagarray);
    let formData = new FormData();
    formData.append('image_original_name', this.image);
    this.request.gender = this.imageform.controls['gender'].value;
    this.request.category = this.imageform.controls['category'].value;
    this.request.hair_length = this.imageform.controls['hair_length'].value;
    this.request.hair_type = this.imageform.controls['hair_type'].value;
    this.request.hair_color = this.imageform.controls['hair_color'].value;
    this.request.age = this.imageform.controls['age'].value;
    this.request.tags = this.imageform.controls['tags'].value;
    this.request.skin_colour = this.imageform.controls['skin_colour'].value;
    this.request.harmony = this.imageform.controls['harmony'].value;
    this.request.faceshape = this.imageform.controls['faceshape'].value;
    this.request.products = this.imageform.controls['products'].value;
    let requestNew = JSON.stringify(this.request);
    // console.log(requestNew);
    formData.append('request', requestNew);
    if (this.imageform.invalid) {
      return;
    }
    if (this.isAddMode) {
      this.createImage(formData);
    } else {
      this.updateImage(formData);
    }
  }
  createImage(formData: any) {
    this.imageService.add(formData).subscribe(
      (data) => {
        let imageAdded = this.translateService.instant('image.imageAdded');
        this.alertService.showSuccessAlert(this.successDialog, imageAdded);
        this.router.navigate(['imageList']);
      },
      (error: HttpErrorResponse) => {
        //console.log(error.name + ' ' + error.message);
        this.alertService.showDangerAlert(
          this.errorDialog,
          this.somethingWrong
        );
      }
    );
  }
  updateImage(formData: any) {
    this.imageService.update(this.imageId, formData).subscribe(
      (data) => {
        this.router.navigate(['imageList']);
        let imageUpdate = this.translateService.instant('image.imageUpdateMsg');
        this.alertService.showSuccessAlert(this.successDialog, imageUpdate);
      },
      (error: HttpErrorResponse) => {
        // console.log(error.name + ' ' + error.message);
        this.alertService.showDangerAlert(
          this.errorDialog,
          this.somethingWrong
        );
      }
    );
  }
  editImage(id: any) {
    this.imageService.getById(id).subscribe(
      (data) => {
        this.editData = data;
        // console.log(this.editData['data']);
        this.imgurl = this.editData['data'].image_path_name;
        this.formValidation.category.setValue(this.editData['data'].category);
        this.formValidation.faceshape.setValue(this.editData['data'].faceshape);
        this.gendervalue = this.editData['data'].gender;
        this.harmonyvalue = this.editData['data'].harmony;
        this.formValidation.hair_length.setValue(
          this.editData['data'].hair_length
        );
        this.formValidation.hair_type.setValue(this.editData['data'].hair_type);
        this.formValidation.hair_color.setValue(
          this.editData['data'].hair_color
        );
        this.formValidation.age.setValue(this.editData['data'].age);
        for (var i = 0; i < this.editData['data'].tags.length; i++) {
          this.tagarray.push(this.editData['data'].tags[i].id);
        }
        this.hairColorArray = this.editData['data'].hair_color;
        this.hairTypehArray = this.editData['data'].hair_type;
        this.hairLengthArray = this.editData['data'].hair_length;
        this.ageArray = this.editData['data'].age;
        this.skinColorArray = this.editData['data'].skin_colour;
        this.formValidation.products.setValue(this.editData['data'].products);
      },
      (error: HttpErrorResponse) => {
        // console.log(error.name + ' ' + error.message);
        // this.alertService.showDangerAlert('Error', 'Something went wrong while adding an salon detail.');
      }
    );
  }

  checkExtension(file: any) {
    let mimeType = ['image/png', 'image/jpeg', 'image/jpg'];
    return mimeType.indexOf(file.type);
  }

  getTagList() {
    this.tagService.getTagList().subscribe(
      (data) => {
        if (data.is_error == false) {
          this.tagList = data.data;
        }
      },
      (error: HttpErrorResponse) => {
        this.alertService.showDangerAlert(
          this.errorDialog,
          this.somethingWrong
        );
      }
    );
  }

  getAllProduct() {
    this.productService.getProductList().subscribe(
      (data) => {
        if (data.is_error == false) {
          this.productList = data.data;
          console.log('product',this.productList)
        } else {
          //	this.alertService.showDangerAlert('Error', 'Product not exist.');
        }
      },
      (error: HttpErrorResponse) => {
        this.alertService.showDangerAlert(
          this.errorDialog,
          this.somethingWrong
        );
      }
    );
  }

  get formValidation() {
    return this.imageform.controls;
  }

  removeSelectedFile(index: any) {
    this.images.splice(index, 1);
  }
  onChangeSkinColor(index: number, _id: any, isChecked: any) {
    if (isChecked.target.checked) {
      this.skinColorArray.push(_id);
    } else {
      this.skinColorArray.splice(this.hairLengthArray.indexOf(_id), 1);
    }
    this.formValidation.skin_colour.setValue(this.skinColorArray);
    // console.log(this.formValidation.skin_colour);
  }

  onChange(index: number, _id: string, isChecked: any) {
    if (isChecked.target.checked) {
      this.tagarray.push(_id);
    } else {
      this.tagarray.splice(this.tagarray.indexOf(_id), 1);
    }
    this.formValidation.tags.setValue(this.tagarray);
  }
  onItemChange(event: any) {
    this.gendervalue = event.target.value;
  }
  onharmonyChange(event: any) {
    this.harmonyvalue = event.target.value;
  }

  onChangeHairLength(index: number, _id: number, isChecked: any) {
    if (isChecked.target.checked) {
      this.hairLengthArray.push(_id);
    } else {
      this.hairLengthArray.splice(this.hairLengthArray.indexOf(_id), 1);
    }
    this.formValidation.hair_length.setValue(this.hairLengthArray);
  }

  onChangeHairType(index: number, _id: number, isChecked: any) {
    if (isChecked.target.checked) {
      this.hairTypehArray.push(_id);
    } else {
      this.hairTypehArray.splice(this.hairTypehArray.indexOf(_id), 1);
    }
    this.formValidation.hair_type.setValue(this.hairTypehArray);
  }

  onChangeAge(index: number, _id: number, isChecked: any) {
    if (isChecked.target.checked) {
      this.ageArray.push(_id);
    } else {
      this.ageArray.splice(this.ageArray.indexOf(_id), 1);
    }
    this.formValidation.age.setValue(this.ageArray);
  }
  onChangeHairColor(index: number, _id: number, isChecked: any) {
    if (isChecked.target.checked) {
      this.hairColorArray.push(_id);
    } else {
      this.hairColorArray.splice(this.hairColorArray.indexOf(_id), 1);
    }
    this.formValidation.hair_color.setValue(this.hairColorArray);
  }
}
